export default "__VITE_ASSET__6da6641a__"